export default __webpack_public_path__ + "static/media/CETOWhitepaper1.6.db53df38.pdf";